module.exports = __webpack_public_path__ + "img/home-service-xingbian.89a639ed.png";